import React, { useState, useRef, useEffect } from 'react';
import './shapp_p1.css';
import 'leaflet/dist/leaflet.css';
import './footer-bs.css';
import { MapComponentOL } from './components_openlab/MapComponentOL';
import Attribution from './attribution';
import Legend from './legend';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Shapp_OL() {

    const { t, i18n } = useTranslation();
    const [selectedMenu, setSelectedMenu] = useState('layer');
    const [layerFilters, setLayerFilters] = useState({
        ProveGeognostiche: true,
        ProveGeofisiche: true,
        SondaggiPozzi:true,
        CPT: true,
        CPTU: true,
        CPTE: true,
        DMT: true,
        SDMT: true,
        DIN:true,
        POZZO:true,
        SONDAGGIO: true,
        SONDAGGIO_IDROCARBURI: true,
        SONDAGGIO_OFFSHORE: true,
        HVSR: true,
        MASW: true,
        REMI:true,
        DH: true,
        CH:true,
        ARRAY_SISMICO:true,
    });

    const [infotabWidth, setInfotabWidth] = useState(280);
    const infotabRef = useRef(null);
    const [isResizing, setIsResizing] = useState(false);
    const startX = useRef(0);
    const startWidth = useRef(0);

    const navigate = useNavigate();

    const handleLayerFilterChange = (event) => {
        const { name, checked } = event.target;
        setLayerFilters(prevFilters => {
            const updatedFilters = { ...prevFilters, [name]: checked };

            if (name === 'ProveGeognostiche') {
                updatedFilters.CPT = checked;
                updatedFilters.CPTU = checked;
                updatedFilters.CPTE = checked;
                updatedFilters.DMT = checked;
                updatedFilters.SDMT = checked;
                updatedFilters.DIN = checked;
            }
            if (name === 'ProveGeofisiche') {
                updatedFilters.HVSR = checked;
                updatedFilters.MASW = checked;
                updatedFilters.REMI = checked;
                updatedFilters.DH = checked;
                updatedFilters.CH = checked;
                updatedFilters.ARRAY_SISMICO = checked;
            }
            if (name === 'SondaggiPozzi') {
                updatedFilters.POZZO = checked;
                updatedFilters.SONDAGGIO = checked;
                updatedFilters.SONDAGGIO_IDROCARBURI = checked;
                updatedFilters.SONDAGGIO_OFFSHORE= checked;
            }

            if (!updatedFilters.CPT && !updatedFilters.CPTU && !updatedFilters.CPTE && !updatedFilters.DMT && !updatedFilters.SDMT && !updatedFilters.DIN) {
                updatedFilters.ProveGeognostiche = false;
            }
            if (!updatedFilters.HVSR && !updatedFilters.MASW && !updatedFilters.DH && !updatedFilters.CH && !updatedFilters.ARRAY_SISMICO && !updatedFilters.REMI) {
                updatedFilters.ProveGeofisiche = false;
            }
            if (!updatedFilters.POZZO && !updatedFilters.SONDAGGIO && !updatedFilters.SONDAGGIO_IDROCARBURI && !updatedFilters.SONDAGGIO_OFFSHORE) {
                updatedFilters.SondaggiPozzi = false;
            }

            return updatedFilters;
        });
    };

    const renderContent = () => {
        console.log('Selected Menu:', selectedMenu);
        switch (selectedMenu) {
            case 'layer':
                return (
                    <div>
                        <div className="layer-categories">
                            <div className="category">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="ProveGeognostiche"
                                        checked={layerFilters.ProveGeognostiche}
                                        onChange={handleLayerFilterChange}
                                    />
                                    {t('pages.layer.Pla1')}
                                </label>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="CPT"
                                            checked={layerFilters.CPT}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_cpt.png" height="20" alt="CPT" className="filter-image"/>
                                        {t('pages.layer.Tla1')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="CPTU"
                                            checked={layerFilters.CPTU}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_cptu.png" height="20" alt="CPTU" className="filter-image"/>
                                        {t('pages.layer.Tla2')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="CPTE"
                                            checked={layerFilters.CPTE}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_cpte.png" height="20" alt="CPTE" className="filter-image"/>
                                        {t('pages.layer.Tla3')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="DMT"
                                            checked={layerFilters.DMT}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_dmt.png" height="20" alt="DMT" className="filter-image"/>
                                        {t('pages.layer.Tla4')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="SDMT"
                                            checked={layerFilters.SDMT}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_sdmt.png" height="20" alt="SDMT" className="filter-image"/>
                                        {t('pages.layer.Tla5')}
                                    </label>
                                </div>

                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="DIN"
                                            checked={layerFilters.DIN}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_din.png" height="20" alt="SDMT" className="filter-image"/>
                                        {t('pages.layer.Tla6')}
                                    </label>
                                </div>
                            </div>

                            <div className="category">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="ProveGeofisiche"
                                        checked={layerFilters.ProveGeofisiche}
                                        onChange={handleLayerFilterChange}
                                    />
                                    {t('pages.layer.Pla2')}
                                </label>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="HVSR"
                                            checked={layerFilters.HVSR}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_hvsr.png" height="20" alt="HVSR" className="filter-image"/>
                                        {t('pages.layer.Tla7')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="MASW"
                                            checked={layerFilters.MASW}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_masw.png" height="20" alt="MASW" className="filter-image"/>
                                        {t('pages.layer.Tla8')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="REMI"
                                            checked={layerFilters.REMI}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_remi.png" height="20" alt="REMI" className="filter-image"/>
                                        {t('pages.layer.Tla9')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="DH"
                                            checked={layerFilters.DH}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_dh.png" height="20" alt="DH" className="filter-image"/>
                                        {t('pages.layer.Tla10')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="CH"
                                            checked={layerFilters.CH}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_ch.png" height="20" alt="CH" className="filter-image"/>
                                        {t('pages.layer.Tla11')}
                                    </label>
                                </div>
                                <div className="inline-filters">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="ARRAY_SISMICO"
                                            checked={layerFilters.ARRAY_SISMICO}
                                            onChange={handleLayerFilterChange}
                                        />
                                        <img src="/icon_array.png" height="20" alt="ARRAY_SISMICO" className="filter-image"/>
                                        {t('pages.layer.Tla12')}
                                    </label>
                                </div>
                            </div>

                            <div className="category">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="SondaggiPozzi"
                                        checked={layerFilters.SondaggiPozzi}
                                        onChange={handleLayerFilterChange}
                                    />
                                    {t('pages.layer.Pla2')}
                                </label>
                                    <div className="inline-filters">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="POZZO"
                                                checked={layerFilters.POZZO}
                                                onChange={handleLayerFilterChange}
                                            />
                                            <img src="/icon_pozzo.png" height="20" alt="POZZO" className="filter-image"/>
                                            {t('pages.layer.Tla13')}
                                        </label>
                                    </div>

                                    <div className="inline-filters">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="SONDAGGIO"
                                                checked={layerFilters.SONDAGGIO}
                                                onChange={handleLayerFilterChange}
                                            />
                                            <img src="/icon_sondaggio.png" height="20" alt="SONDAGGIO" className="filter-image"/>
                                            {t('pages.layer.Tla14')}
                                        </label>
                                    </div>

                                    <div className="inline-filters">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="SONDAGGIO_IDROCARBURI"
                                                checked={layerFilters.SONDAGGIO_IDROCARBURI}
                                                onChange={handleLayerFilterChange}
                                            />
                                            <img src="/icon_idrocarburi.png" height="20" alt="SONDAGGIO_IDROCARBURI" className="filter-image"/>
                                            {t('pages.layer.Tla15')}
                                        </label>
                                    </div>
                                    <div className="inline-filters">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="SONDAGGIO_OFFSHORE"
                                                checked={layerFilters.SONDAGGIO_OFFSHORE}
                                                onChange={handleLayerFilterChange}
                                            />
                                            <img src="/icon_soffshore.png" height="20" alt="SONDAGGIO_OFFSHORE" className="filter-image"/>
                                            {t('pages.layer.Tla16')}
                                        </label>
                                    </div>

                            </div>
                            <div className="attribution-button" style={{ marginTop: 'auto', padding: '10px' }}>
                            <button onClick={() => navigate('/legend')}>
                              📑 {t('pages.layer.ld1')}
                            </button>
                          </div>
                            <div className="attribution-button" style={{ marginTop: 'auto', padding: '10px' }}>
                            <button onClick={() => navigate('/attribution')}>
                              📑 {t('pages.layer.ld2')}
                            </button>
                          </div>

                        </div>
                    </div>
                );
                return null;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            if (infotabRef.current) {
                const handleWrapper = document.querySelector('.resize-handle');
                if (handleWrapper) {
                    handleWrapper.style.top = `${infotabRef.current.getBoundingClientRect().top}px`;
                    handleWrapper.style.height = `${infotabRef.current.clientHeight}px`;
                }
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [infotabWidth]);

    const handleMouseDown = (event) => {
        setIsResizing(true);
        startX.current = event.clientX;
        startWidth.current = infotabRef.current.offsetWidth;

        // Event handler usa direttamente i valori iniziali, senza leggere subito lo stato
        const handleMouseMove = (e) => {
            // Non dipendiamo da isResizing qui, funziona comunque
            const newWidth = Math.max(100, startWidth.current + (e.clientX - startX.current));
            setInfotabWidth(newWidth);
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    return (

                <div className="Principal-wg">
                    <div className="layoutapp">
                        <div className="infotab" ref={infotabRef} style={{ width: `${infotabWidth}px` }}>
                            <div className="Title-sh">
                                {t('pages.layer.Tgla1')}
                            </div>
                            <hr className="divider" />
                            <div className="menu">
                                <ul>
                                    <li onClick={() => setSelectedMenu('layer')} className={selectedMenu === 'layer' ? 'active' : ''}>{t('pages.layer.Tpla1')}</li>

                                </ul>
                            </div>
                            {renderContent()}
                        </div>
                        <div className="App">
                            <MapComponentOL filters={layerFilters} />
                            <div
                                    className="resize-handle"
                                    onMouseDown={handleMouseDown}
                                />
                        </div>

                    </div>
                </div>
            

    );
}

export default Shapp_OL;




















